import { render } from "./CallToActionComponent.vue?vue&type=template&id=225df693"
import script from "./CallToActionComponent.vue?vue&type=script&lang=js"
export * from "./CallToActionComponent.vue?vue&type=script&lang=js"

import "./CallToActionComponent.vue?vue&type=style&index=0&id=225df693&lang=css"

import exportComponent from "/Users/ricpp/Development/boldbrush/blog_post_editor/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__